<template>
    <div class="shipDetail-royalShips">
        <div class="shipDetail-commonTitle">
            <div class="shipDetail-commonTitleLine"></div>
            <div class="shipDetail-commonTxt">皇家船队</div>
        </div>
        <div class="swiper-container swiper-container3 swiper-container-horizontal"
        v-swiper:bannerSwiper="swiperOptions" 
            v-if="showShips&&showShips.length>0">
            <!-- Slides wrapper -->
            <div class="swiper-wrapper">
                <div class="swiper-slide" style="width: 351px;" v-for="(ship, i) in showShips" :key="('ship_'+i)">
                    <div class="intro_headImg">
                        <img class="headImg" :src="ship.imageUrl"
                            :alt="ship.shipCNName">
                    </div>
                    <div class="shipIndex-ship-itemName">
                        <div>
                            <p class="shipIndex-ship-itemCName">{{ship.shipCNName}}</p>
                            <p class="shipIndex-ship-itemEName">{{ship.subTitle}}</p>
                        </div>
                    </div>
                    <router-link class="hold-shipLink external" :to="shipLink(ship.shipCode)"></router-link>
                </div>
            </div>
            <!-- 分页 -->
            <div class="swiper-pagination swiper-pagination-clickable swiper-pagination-bullets"
                style="margin-left: -34px;">
                <span class="swiper-pagination-bullet bannerDot" :class="{ active: i==0}"
                v-for="(ship, i) in showShips" :key="('shipIndex_'+i)"
                    ></span>
            </div>
            <!-- 左右按钮 -->
            <div class="swiper-button-prev" @click="bannerImageChange('prev')">
                <div></div>
            </div>
            <div class="swiper-button-next" @click="bannerImageChange('next')">
                <div class=""></div>
            </div>
        </div>
    </div>
</template>

<script>
import { directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
export default {
    name: "RoyalExperienceShips",
    directives: {
        swiper: directive
    },
    props: {
        ships: {
            type: Array,
            default () {
                return []
            }
        }
    },
    data () {
        return {
            swiperOptions: {
                loop: true,
                on: {
                    slideChangeTransitionEnd: this.onBannerSliderChange
                }
            }
        }
    },
    methods: {
        bannerImageChange(slide) {
            if (slide == 'prev') {
                this.bannerSwiper.slidePrev()
            } else {
                this.bannerSwiper.slideNext()
            }
        },
        onBannerSliderChange () {
            if (this.bannerSwiper) {
                const index = this.bannerSwiper.realIndex
                const dots = document.getElementsByClassName('bannerDot')
                for (let i = 0; i < dots.length; i++) {
                    var dot = dots[i]
                    dot.classList.remove('active')
                }
                dots[index].className += ' active'
            }
        },
        shipLink (shipCode) {
            return `/content/taste/ships/${shipCode}` 
        }
    },
    computed: {
        showShips () {
            return this.ships ? this.ships.filter(r=>r.isInHp) : []
        }
    }
}
</script>

<style lang="less" scoped>
.shipDetail-royalShips {
    width: 100%;
    background-color: #fff;
    padding: 0 3.2% 10px 3.2%;
    .shipDetail-commonTitle {
        padding: 27px 0;
        position: relative;
        .shipDetail-commonTitleLine {
            height: 1px;
            background-color: #fecc46;
        }
        .shipDetail-commonTxt {
            width: 80px;
            position: absolute;
            top: 18px;
            left: 50%;
            margin-left: -40px;
            padding: 0 1.867%;
            background-color: #fff;
            text-align: center;
            color: #061556;
            font-size: 13px;
        }
    }

    .swiper-container {
        padding-bottom: 0;
        .intro_headImg img {
            width: 100%;
            height: 130px;
        }
        .shipIndex-ship-itemName {
            background-color: rgba(0,0,0,.3);
            width: 100%;
            height: 100%;
            display: flex;
            display: -webkit-flex;
            justify-content: center;
            align-items: center;
            position: absolute;
            top: 0;
            left: 0;
            text-align: center;
            p {
                margin: 0;
                color: #fff;
            }
            .shipIndex-ship-itemCName {
                font-size: 18px;
            }
            .shipIndex-ship-itemEName {
                font-size: 16px;
                font-style: italic;
            }
        }
        .hold-shipLink {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            z-index: 22;
        }
    }

    .swiper-pagination {
        bottom: 8px;
        left: 50%;
        background-color: rgba(0,0,0,.3);
        z-index: 4;
        width: auto;
        display: flex;
        padding: 2px 7px;
        border-radius: 6px;
        .swiper-pagination-bullet {
            background-color: #fff;
            opacity: 1;
            width: 6px;
            height: 6px;
        }
        .swiper-pagination-bullet.active {
            background-color: #febd11;
            width: 12px;
            height: 6px;
            border-radius: 3px;
        }
    }

    .swiper-button-prev, .swiper-button-next {
        background-image: none;
        width: 29px;
        top: 46px;
        height: 50%;
    }

    .swiper-button-prev > div {
        width: 12px;
        height: 21px;
        top: 15px;
        position: relative;
        background-image: url('https://resource.rcclchina.com.cn/shipDetail/shipLeftArrow.png');
        background-size: 100%;
    }
    .swiper-button-next > div {
        width: 12px;
        height: 21px;
        top: 15px;
        // left: 15px;
        position: relative;
        background-image: url('https://resource.rcclchina.com.cn/shipDetail/shipRightArrow.png');
        background-size: 100%;
    }

    .swiper-button-prev:after, .swiper-button-next:after {
        content: ''
    }
}
</style>